import { createClient } from "@supabase/supabase-js";

// The AI tool moved this key to the frontend when the build said it was "undefined in the browser".
// The service_role key skips every RLS policy: never ship it to the browser.
const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY,
);

export async function loadTasks() {
  const { data } = await supabase.from("tasks").select();
  return data;
}
